import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

import useStyles from './styles';

const DialogButton = ({ className, title, handleClick, color, ...restProps }) => {
    const classes = useStyles();
    return (
        <Button color={color} onClick={handleClick} className={clsx(classes.root, className)} {...restProps}>
            {title}
        </Button>
    );
};

DialogButton.defaultProps = {
    color: 'secondary',
    className: undefined,
    handleClick: undefined,
};

DialogButton.propTypes = {
    className: PropTypes.string,
    color: PropTypes.oneOf(['primary', 'secondary']),
    title: PropTypes.node.isRequired,
    handleClick: PropTypes.func,
};

export default DialogButton;
